import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, IonItemSliding, ModalController, Platform, PopoverController } from '@ionic/angular';
import { deleteField } from 'firebase/firestore';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ComponentsService } from 'src/app/services/components/components.service';
import { PosService } from 'src/app/services/pos/pos.service';
import { PrintService } from 'src/app/services/print/print.service';
import { setDecimals } from 'src/app/utils/decimal';
import { EditClientComponent } from '../../clients/edit-client/edit-client.component';
import { PaymentMethodComponent } from '../../payments/payment-method/payment-method.component';
import { SuccessPaymentComponent } from '../../payments/success-payment/success-payment.component';
import { ModalBaseComponent } from '../../shared/modal-base/modal-base.component';
import { NumberComponent } from '../../tables/number/number.component';
import { ClientsComponent } from '../clients/clients.component';
import { DeliveriesComponent } from '../deliveries/deliveries.component';
import { EditItemComponent } from '../edit-item/edit-item.component';
import { TicketOptionsComponent } from '../ticket-options/ticket-options.component';
import { TransferTicketsComponent } from './../../tables/transfer-tickets/transfer-tickets.component';
@Component({
    selector: 'app-ticket',
    templateUrl: './ticket.component.html',
    styleUrls: ['./ticket.component.scss'],
})

export class TicketComponent implements OnInit, OnChanges {
    @ViewChild(IonItemSliding) item_slides: IonItemSliding;
    @Input() order_pos: any;
    branch: any;
    order: any;
    total: any = 0;
    total_payments: any = 0;
    total_iva: number = 0;
    payments: any = [];
    client: any = false;
    loading: any = true;
    tip: any = 0;
    gran_discount: any;
    hidden_taxes: any = 0;
    open_payment_modal = false;
    iva_discount: any = 0;
    iva_rete: any = 0;
    discount_card: any = null;
    totalWithoutDiscount = 0;
    new_order: any = false;
    exempt_taxes: any = 0;
    all_items: any[] = [];

    constructor(
        public popoverController: PopoverController,
        public modalController: ModalController,
        public api: ApiService,
        public auth: AuthService,
        public components: ComponentsService,
        public router: Router,
        public actvRoute: ActivatedRoute,
        public alertController: AlertController,
        public pos: PosService,
        public printer: PrintService,
        public platform: Platform
    ) {
        /* This is a subscription to an event that is triggered when an item is added to the ticket. */
        this.pos.UpdateItemsEvent.subscribe(() => {
            this.getTotal();
            this.updateItems();
        });
        
        this.pos.removeItemsEvent.subscribe(() => {
            this.getTotal();
            this.updateItems();
        });

        this.pos.changeFiscalType.subscribe((fiscal_type) => {
            if (fiscal_type) {
                this.order.tax_receipt = fiscal_type;
            }

            this.getTotal();
        });

        this.pos.cancelOrderEvent.subscribe(async (order_key) => {
            this.discount_card = null;
            this.new_order = false;
            this.all_items = [];

            if (!pos.type) {
                this.order = false;
                this.payments = [];
                this.getTotal();
            }
        });
    }

    ngOnInit() {
        this.payments = [];
        this.all_items = [];
        this.discount_card = null;
        this.loading = true;
        this.branch = this.auth.branch_data;

        if (!this.order_pos) {
            this.order = false;
            this.pos.client = false;
            this.pos.exempt = false;
            this.loading = false;
            this.getTotal();
            this.updateItems();
        } else {
            this.order = this.order_pos;
            this.order.items = [];
            this.order.discounts = [];
            this.pos.delivery = this.order.delivery;
            this.pos.client = this.order.client;
            this.discount_card = this.order.discount_card;

            if (this.order.custom_tip) {
                this.pos.custom_tip = this.order.custom_tip;
            }

            if (this.order.client && this.order.client.exempt) {
                this.pos.exempt = true;
            }

            if (this.auth.account_data?.people_confirmation && this.order.type === 'tables' && !this.new_order) this.updatePeople();

            this.api.getRef(`accounts/${this.auth.account}/ticket_items`).ref
                .where('order_key', '==', this.order.$key)
                .onSnapshot((snapshots: any) => {
                    snapshots.docChanges().forEach(element => {
                        if (element.type == 'added') {
                            let item = element.doc.data();
                            item.$key = element.doc.id;
                            if (item.is_promotion) {
                                item.quantity = 1;
                            }

                            if (this.order.items) {
                                const found = this.order.items.findIndex(element => element.$key == item.$key);
                                if (found < 0) {
                                    this.order.items.push(item);
                                    this.pos.items_count += item.quantity;
                                }
                            }
                            if (this.order.items) {
                                this.order.items.sort(function (a, b) {
                                    var orderA = a.creation_date, orderB = b.creation_date;
                                    return orderA - orderB;
                                });
                            }
                        } else if (element.type == 'modified') {
                            let item = element.doc.data();
                            item.$key = element.doc.id;
                            const found = this.order.items.findIndex(element => element.$key == item.$key);
                            this.order.items[found] = item;
                            this.getTotal();
                        } else if (element.type == 'removed') {
                            let item = element.doc.data();
                            item.$key = element.doc.id;
                            const found = this.order.items.findIndex(element => element.$key == item.$key);
                            this.order.items.splice(found, 1);
                            this.getTotal();
                        }
                    });

                    this.updateItems();
                    this.getTotal();
                    this.pos.order = this.order;
                    this.loading = false;
                });

            this.api.getRef(`accounts/${this.auth.account}/ticket_discounts`).ref
                .where('order_key', '==', this.order.$key)
                .onSnapshot((snapshots: any) => {
                    this.order.discounts = [];
                    snapshots.docChanges().forEach(element => {
                        if (element.type == 'added') {
                            let discount = element.doc.data();
                            discount.$key = element.doc.id;
                            this.order.discounts.push(discount);
                            this.getTotal();
                        } else if (element.type == 'modified') {
                            let discount = element.doc.data();
                            discount.$key = element.doc.id;
                            this.order.discounts[element.oldIndex] = discount;
                            this.getTotal();
                        } else if (element.type == 'removed') {
                            this.order.discounts.splice(element.oldIndex, 1);
                            this.getTotal();
                        }
                    });

                    this.api.getRef(`accounts/${this.auth.account}/ticket_payments`).ref
                        .where('order_key', '==', this.order.$key)
                        .orderBy('creation_date')
                        .onSnapshot((snapshots: any) => {
                            snapshots.docChanges().forEach(element => {
                                if (element.type == 'added') {
                                    let payment = element.doc.data();
                                    payment.$key = element.doc.id;
                                    if (payment.creation_date !== null) {
                                        payment.creation_date = payment.creation_date.toDate();
                                    }
                                    this.payments.push(payment);
                                    this.getTotal();
                                }
                            });

                            if (this.open_payment_modal) {
                                this.open_payment_modal = false;
                                this.openPaymentModal();
                            }
                        }, err => {
                            console.log(err);
                        });
                });

        };

    };

    ngOnChanges(changes: SimpleChanges) {
        if (changes.order_pos && !changes.order_pos.firstChange) {
            this.order_pos = changes.order_pos.currentValue;
            this.ngOnInit();
        };
    };

    getTotal() {
        this.total = 0;
        this.total_payments = 0;
        this.gran_discount = 0;
        this.hidden_taxes = 0;
        this.iva_discount = 0;
        this.exempt_taxes = 0;
        this.iva_rete = 0;
        this.pos.exempt = false;

        let items = [...this.pos.items];
        let discounts = [...this.pos.discounts];

        if (this.order) {
            items = items.concat(this.order.items);
            discounts = discounts.concat(this.order.discounts);
        }

        if ((this.order.client && this.order.client.exempt) || this.pos.client && this.pos.client.exempt) {
            this.pos.exempt = true;
        }

        let item_discounts = 0;

        items.forEach(element => {
            item_discounts += element.total_discount || 0;
            let items = element.is_promotion ? [...element.x_items, ...element.y_items] : [element];

            this.setTaxesItem(items, element);

            if (element.is_promotion) {
                element.hidden_taxes = 0;
                element.x_items.concat(element.y_items).forEach(promoElement => {
                    element.hidden_taxes += promoElement.hidden_taxes;
                });
            }

            this.total += setDecimals(element.price * element.quantity);
        });

        this.payments.forEach(element => {
            this.total_payments += element.total;
        });

        this.totalWithoutDiscount = this.total;

        discounts.forEach(discountElement => {
            discountElement.total_discount = 0;
            discountElement.iva_discount = 0;

            items.forEach(item => {
                let discount = 0;

                if (discountElement.type == 'percentage') {
                    discount = (((item.price * item.quantity) * discountElement.amount / 100) * 100) / 100;
                } else if (discountElement.type == 'fixed') {
                    discount = discountElement.amount / items.length;
                    if (discount > this.total) discount = this.total;
                }

                let total_rate = 1;
                let taxes = [];

                if (this.auth.account_data.fiscal && this.auth.account_data.fiscal.type == 'dte') {
                    taxes = item.is_variant ? item.parent?.taxes_item : item?.taxes_item;
                    total_rate = taxes.reduce((sum, tax) => sum + Number(tax.rate || 0), 0);
                }

                console.log('discount', discount);
                console.log('total_rate', total_rate);

                let _tax_discount = 0;

                taxes.forEach(tax => {
                    let discount_value = (discount / ((total_rate * 0.01) + 1)) * (tax.rate / 100)
                    _tax_discount += discount_value;
                    tax.discount = discount_value;
                })

                discount -= _tax_discount;

                if (this.pos.exempt) {
                    let calc_exempt = 0;
                    this.pos.client.exempt_taxes.forEach(exempt_tax => {
                        calc_exempt += _tax_discount * (exempt_tax.rate / total_rate);
                    });
                    _tax_discount -= calc_exempt;
                }

                discountElement.total_discount += discount;
                discountElement.iva_discount += _tax_discount;
                item.discount = (discount + _tax_discount);

                this.total -= (discount + _tax_discount);
                this.hidden_taxes -= _tax_discount;
                this.gran_discount += discount;
                this.iva_discount += _tax_discount;
            })

            if (this.total < 0) this.total = 0;
        });

        if (this.branch.active_tip && (this.order.type == 'tables' || this.pos.type == 'tables')) {
            if (this.branch.active_tip && !this.order.tip_removed) {

                let current_tip = this.branch.tip;

                if (this.pos.custom_tip) {
                    current_tip = this.pos.custom_tip.amount;
                }

                if (this.branch.include_taxes_tip) {
                    if (this.branch.include_discounts_tip) {
                        this.tip = (((this.total) * Number(current_tip)) / 100);
                    } else {
                        this.tip = (((this.total + this.gran_discount + this.iva_discount) * Number(current_tip)) / 100);
                    }
                } else {
                    if (this.branch.include_discounts_tip) {
                        this.tip = (((this.total) * Number(current_tip)) / 100);
                    } else {
                        this.tip = ((((this.total + this.gran_discount + this.iva_discount)) * Number(current_tip)) / 100);
                    }
                }
                this.tip = Math.round(this.tip * 100) / 100;
                this.tip = this.tip;

                if (this.pos.custom_tip) {
                    if (this.pos.custom_tip.type == 'fixed') {
                        this.tip = this.pos.custom_tip.amount;
                    }
                }

            } else {
                this.tip = 0;
            }

        } else {
            let current_tip = 0;

            if (this.pos.custom_tip && this.pos.custom_tip.type == 'percentage') {
                current_tip = this.pos.custom_tip.amount;
                if (this.branch.include_taxes_tip) {
                    if (this.branch.include_discounts_tip) {
                        this.tip = (((this.total) * Number(current_tip)) / 100);
                    } else {
                        this.tip = (((this.total + this.gran_discount + this.iva_discount) * Number(current_tip)) / 100);
                    }
                } else {
                    if (this.branch.include_discounts_tip) {
                        this.tip = (((this.total) * Number(current_tip)) / 100);
                    } else {
                        this.tip = ((((this.total + this.gran_discount + this.iva_discount)) * Number(current_tip)) / 100);
                    }
                }
                this.tip = Math.round(this.tip * 100) / 100;
                this.tip = this.tip;
            } else if (this.pos.custom_tip && this.pos.custom_tip.type == 'fixed') {
                this.tip = this.pos.custom_tip.amount;
            } else {
                this.tip = 0;
            }
        }

        let total = this.total - this.hidden_taxes;
        const client = this.order?.client || this.pos?.client;

        if (client && total > 100 && client.large_contributor) {
            this.iva_rete = total * 0.01;
            this.total -= this.iva_rete;
        }

        if (this.total < 0) {
            this.total = 0;
            this.total_payments = 0;
            this.gran_discount = 0;
            this.hidden_taxes = 0;
            this.iva_discount = 0;
            this.pos.exempt = 0;
        }
    }

    setTaxesItem(all_items, item) {
        if (item.is_promotion) item.price = item.base_price;

        all_items.forEach(element => {
            element.hidden_taxes = 0;
            element.exempt = 0;
            element.quantity = Number(element.quantity);
            const taxes = element.is_variant ? element.parent?.taxes_item : element?.taxes_item;

            if (taxes?.length) {
                const sortedTaxes = taxes.sort((a, b) => {
                    if (a.included === b.included) return 0;
                    return a.included ? -1 : 1;
                });

                sortedTaxes.forEach(tax => {
                    if (!tax.value) tax.value = 0;
                    tax.rate = Number(tax.rate);
                    tax.exempt = false;

                    this.components.getTaxes(element, tax);

                    if (this.pos.exempt) {
                        if (this.pos.client && !this.pos.client.exempt_taxes) {
                            this.pos.client.exempt_taxes = [{
                                tax_key: tax.$key,
                                rate: tax.rate,
                                value: tax.value
                            }]
                        }

                        const found = this.pos.client.exempt_taxes.some(exempt => exempt.tax_key === tax.$key);
                        if (found) {
                            tax.exempt = true;
                            element.exempt += tax.value;
                            this.exempt_taxes += tax.value;
                        }
                    }

                    if (tax.iva) this.total_iva += tax.value;
                    this.hidden_taxes += tax.value;

                    if (item.is_promotion) {
                        item.hidden_taxes += tax.value;

                        if (!tax.included) {
                            item.price += tax.value;
                        }
                    }
                });

                // element.hidden_taxes *= element.quantity;
                element.hidden_taxes = setDecimals(element.hidden_taxes, 8);

            }
        });
    }

    saveOrder(print = false) {
        this.components.showLoader('Guardando orden...').then(() => {
            if (this.pos.items.length > 0 || (this.order && this.pos.discounts.length > 0)) {

                if (this.order) {
                    this.api.updateOrder(this.order).then(data => {
                        this.components.dismissLoader();
                    }, err => {
                        this.components.dismissLoader();
                        console.log(err);
                    })
                } else {
                    this.api.addOrder(this.discount_card).then(() => {
                        this.clearAll();
                        if (this.components.isApp()) this.modalController.dismiss();
                        this.components.dismissLoader();
                        this.components.showToast('Orden agregada con exito');
                    }, err => {
                        console.log(err);
                    })
                }
            } else {
                this.components.dismissLoader();
                this.components.showToast('Debes de agregar items para poder continuar', 'error')

            }
        })
    }

    async showAlert(ticket: number) {
        const message = ticket === 0
            ? 'Has completado el máximo de tickets autorizados para emitir, contacta Quanto Support para más información.'
            : `Quedan ${ticket} tickets disponibles para emitir con tu Resolución de Hacienda.`;
        const alert = await this.alertController.create({
            message: message,
            backdropDismiss: false,
            buttons: [
                {
                    text: 'Aceptar',
                    role: 'destructive',
                }
            ]
        });
        await alert.present();
    }
    async payNow(ev) {
        console.log(this.order);

        if (this.auth.branch_data?.fiscal?.res && this.auth.account_data?.fiscal?.type === 'standard' && this.auth.branch_data.country === 'El Salvador') {
            if (this.api.getCurrentTicketNumber() <= 0) return await this.showAlert(this.api.getCurrentTicketNumber())
            await this.api.checkCurrentTicketNumber()
            if (this.api.getCurrentTicketNumber() <= 0) return await this.showAlert(this.api.getCurrentTicketNumber())
        }
        if (this.order.items || this.pos.items.length > 0) {
            this.components.buttonLoad(ev);
            if (this.order) {
                if (this.pos.items.length > 0) {
                    this.api.updateOrder(this.order).then(async data => {
                        await this.getTotal();
                        this.openPaymentModal();
                        this.components.dismissButtonLoad(ev);
                    }, err => {
                        console.log(err);
                        this.components.dismissButtonLoad(ev);
                    })
                } else {
                    this.openPaymentModal();
                    this.components.dismissButtonLoad(ev);

                }

            } else {
                this.api.addOrder(this.discount_card).then(respone => {
                    this.open_payment_modal = true;
                    this.order_pos = respone;
                    this.order_pos.creation_date = new Date();
                    this.new_order = true;
                    this.pos.clearOrder(this.order);
                    this.ngOnInit();
                    this.components.dismissButtonLoad(ev);
                })
            }
        } else {
            this.components.showToast('Debes de agregar items para poder continuar', 'error');
        }

    }

    clearAll() {
        this.order = false;
        this.payments = [];
        this.pos.clearOrder(undefined);
    }

    async openPaymentModal() {
        if (!this.components.isModalPresent) {
            const descuentoTotal = this.order.discounts.reduce((acc, discount) => {
                acc += parseFloat(discount.total_discount) + parseFloat(discount.iva_discount);
                return acc;
            }, 0);

            this.components.isModalPresent = true;

            let params = {
                order_key: this.order.$key,
                gran_total: Math.max(0, (this.total + this.tip)),
                gran_subtotal: Math.max(0, this.total),
                gran_discount: Math.max(0, this.gran_discount),
                gran_hidden_taxes: Math.max(0, this.hidden_taxes),
                gran_tip: Math.max(0, this.tip),
                gran_exempt: Math.max(0, this.exempt_taxes),
                discounts: this.order.discounts,
                branch: this.branch,
                order: this.order,
                iva_rete: this.iva_rete,
                descuentoTotal
            }

            console.log(params);


            if (this.discount_card) {
                params['discount_card'] = this.discount_card
            }

            const modal_payment = await this.modalController.create({
                component: ModalBaseComponent,
                cssClass: 'pay-modal',
                showBackdrop: true,
                componentProps: {
                    rootPage: PaymentMethodComponent,
                    params: params
                },
            });

            let check_dte = true;
            let no_client = false;

            if (this.auth.account_data.fiscal) {
                if (this.auth.account_data.fiscal.type == 'dte') {
                    if (this.pos.client) {
                        if (this.pos.client.type == 'regular' && (!this.pos.client.name || !this.pos.client.email)) {
                            check_dte = false;
                        } else if ((this.pos.client.type == 'legal' || this.pos.client.type == 'natural') && (!this.pos.client.name || !this.pos.client.phone || !this.pos.client.email || !this.pos.client.nit || !this.pos.client.address || !this.pos.client.depto || !this.pos.client.munic)) {
                            check_dte = false;
                        }
                    } else {

                        if (this.order.tax_receipt.type == 'ccf') {
                            check_dte = false;
                            no_client = true;
                        }
                    }
                }
            }

            if (check_dte) {
                await modal_payment.present().then(data => {
                    this.components.isModalPresent = false;
                    this.components.dismissLoader();
                })
            } else {
                this.components.dismissLoader();
                this.components.isModalPresent = false;

                if (no_client) {
                    this.components.showToast('Debes de seleccionar un cliente para el tipo de comprobante de CCF');
                    this.addClient(true);
                } else {
                    let new_class = '';
                    if (this.pos.client.type != 'regular') {
                        new_class = 'two-columns';
                    }
                    this.modalController.create({
                        component: EditClientComponent,
                        cssClass: 'auto-height ' + new_class,
                        animated: true,
                        backdropDismiss: true,
                        componentProps: {
                            client: this.pos.client,
                            dte_valid: true
                        }
                    }).then(async modal => {
                        await modal.present();
                        await modal.present().then(() => {
                            this.components.isModalPresent = false;
                            this.components.dismissLoader();
                        })
                        await modal.onDidDismiss().then(async data => {
                            if (data?.data?.success === false) {
                                await this.invalidDiscountCard(data?.data?.message)
                                return
                            }
                            if (data.data) {
                                this.pos.client = data.data;
                                this.api.updateDocument(`accounts/${this.auth.account}/orders`, this.order.$key, {
                                    client: data.data
                                })
                            }

                        })
                    });
                }
            }

            await modal_payment.onDidDismiss().then(async (data) => {
                if (data?.data?.success === false) {
                    await this.invalidDiscountCard(data?.data?.message)
                    return;
                }
                this.discount_card = null;
                if (data.data) {
                    if (data.data.completed) {
                        if (this.auth.license.membership.type == 'resto') {
                            this.order = '';
                            this.total = 0;
                            this.total_payments = 0;
                            this.payments = [];
                            this.client = false;
                            this.tip = 0;
                            this.hidden_taxes = 0;
                            this.gran_discount = '';
                        } else {
                            this.order = '';
                            this.total = 0;
                            this.total_payments = 0;
                            this.payments = [];
                            this.client = false;
                            this.tip = 0;
                            this.hidden_taxes = 0;
                            this.gran_discount = '';
                        }
                        if (this.components.isApp()) this.modalController.dismiss();
                        this.router.navigate(['/pos']);
                        this.successPaymentModal(data.data.ticket_key);
                    }
                }

            });
        }
    }

    async changeDelivery() {
        if (!this.components.isModalPresent) {
            this.components.isModalPresent = true;

            const modal = await this.modalController.create({
                component: DeliveriesComponent,
                showBackdrop: true
            });

            await modal.present().then(() => { this.components.isModalPresent = false })

            await modal.onDidDismiss().then(data => {
                if (data.data) {
                    let delivery = data.data;

                    if (this.order) {
                        this.api.updateDocument(`accounts/${this.auth.account}/orders`, this.order.$key, {
                            delivery: delivery
                        }).then(() => {
                            this.order.delivery = delivery;
                            this.pos.addDelivery(delivery);
                            this.components.showToast('Delivery agregado a tu orden');
                        }, err => {
                            console.log(err);
                        })
                    } else {
                        this.pos.addDelivery(delivery);
                    }
                }
            });
        }
    }

    async successPaymentModal(ticket_key) {
        if (this.auth.branch_data?.fiscal?.res && this.auth.account_data?.fiscal?.type === 'standard' && this.auth.branch_data.country === 'El Salvador') {
            const current_ticket = this.api.getCurrentTicketNumber() - 1
            if ([100, 50, 25, 10].includes(current_ticket) || current_ticket === 0) return await this.showAlert(current_ticket)
        }
        const modal = await this.modalController.create({
            component: SuccessPaymentComponent,
            cssClass: 'full-modal',
            backdropDismiss: false,
            animated: false,
            componentProps: {
                ticket_key: ticket_key
            }
        });

        await modal.present().then(() => {

        });

        await modal.onDidDismiss().then((data) => {
        })
    }

    async openEditModal(element, already_in_order = true) {
        let item = JSON.parse(JSON.stringify(element));
        console.log(item);
        if (!this.components.isModalPresent) {
            this.components.isModalPresent = true;
            const modal = await this.modalController.create({
                component: ModalBaseComponent,
                cssClass: 'edit-item-modal',
                componentProps: {
                    rootPage: EditItemComponent,
                    params: {
                        item: item,
                        order: this.order,
                        already_in_order: already_in_order
                    }
                },
            });
            await modal.present().then(() => { this.components.isModalPresent = false })

            await modal.onDidDismiss().then(data => {
                if (data.data == 'returned') {
                    this.router.navigate([`pos`]);
                    this.clearAll();
                }
            })

        }
    }

    updateItems() {
        const orderItems = (this.order.items || []).map(item => ({
            ...item,
            already_in_order: true
        }));

        const posItems = (this.pos.items || []).map(item => ({
            ...item,
            already_in_order: false
        }));

        this.all_items = [...orderItems, ...posItems];
    }

    async addClient(is_ccf = false) {
        if (!this.components.isModalPresent) {
            this.components.isModalPresent = true;

            let modal = await this.modalController.create({
                component: ClientsComponent,
                showBackdrop: true,
                cssClass: 'clients-modal',
                componentProps: {
                    order: this.order,
                    is_ccf: is_ccf
                },
            });

            await modal.present().then(data => { this.components.isModalPresent = false })

            await modal.onDidDismiss().then(data => {
                if (data.data) {
                    let client = data.data;
                    if (typeof client.document_type?.code === 'number' && client.document_type) {
                        switch (client.document_type.code) {
                            case 2:
                                client.document_type.code = '02';
                                break;
                            case 3:
                                client.document_type.code = '03'
                                break;

                            default:
                                client.document_type.code = client.document_type.code.toString();
                                break;
                        }
                    }

                    let exempt = false;
                    if (client.exempt) {
                        exempt = true;
                    }

                    if (this.order) {
                        this.api.updateDocument(`accounts/${this.auth.account}/orders`, this.order.$key, {
                            client: client,
                            exempt: exempt,
                        }).then(() => {
                            this.order.client = client;
                            this.order.exempt = exempt;
                            this.pos.client = client;
                            this.pos.exempt = exempt;
                            this.components.showToast('Cliente agregado a tu orden');
                        }, err => {
                            console.log(err);
                        })
                        this.pos.addClient(client);
                    } else {
                        this.pos.exempt = exempt;
                        this.pos.addClient(client);
                    }
                }
            });
        }
    }

    removeClient(client) {
        this.components.showAlert('Eliminar cliente', `El cliente ${client.name} será eliminado del ticket.`,
            [
                {
                    text: 'Cancelar',
                    role: 'cancel'
                },
                {
                    text: 'Eliminar',
                    role: 'destructive',
                    handler: () => {
                        this.item_slides.closeOpened();
                        if (this.order) {

                            let data = {
                                client: deleteField(),
                                exempt: false,
                            };

                            if ((this.order.tax_receipt && this.order.tax_receipt.type == 'ccf') && (this.auth.account_data.fiscal && this.auth.account_data.fiscal.type == 'dte')) {
                                data['tax_receipt'] = {
                                    type: 'invoice'
                                }
                                this.order.type = 'invoice';
                                this.pos.type = 'invoice';
                            }

                            this.order.client = false;
                            this.order.exempt = false;
                            this.pos.client = false;
                            this.pos.exempt = false;

                            this.api.updateDocument(`accounts/${this.auth.account}/orders`, this.order.$key, data).then(() => {
                                this.pos.updateOrderTicket(this.order.$key);
                                this.components.showToast('Cliente eliminado correctamente.')
                            }, err => {
                                console.log(err);
                            })
                        } else {
                            this.pos.removeClient();
                        }
                    }
                },
            ]
        )
    }

    changeKdsType(value, index) {
        this.item_slides.closeOpened();
        this.pos.items[index].kds_type = value;
        this.all_items[index].kds_type = value;
        this.components.showToast('Se cambio el tipo de item.');
    }

    async editDiscount(discount) {

        if (!discount.promotion) {
            const alert = await this.alertController.create({
                header: 'Eliminar descuento',
                message: `Estas seguro que deseas eliminar el descuento ${discount.name ?? discount.note}?, esta acción no se puede revertir.`,
                buttons: [
                    {
                        text: 'Cancelar',
                        role: 'cancel'
                    },
                    {
                        text: 'Remover descuento',
                        role: 'destructive',
                        handler: () => {
                            if (!discount.order_key) {
                                this.pos.removeDiscount(discount);
                                this.components.showToast('Descuento eliminado correctamente.');
                            } else {
                                const discounts = this.order.discounts;
                                this.api.deleteDocument(`accounts/${this.auth.account}/ticket_discounts`, discount.$key).then(() => {
                                    this.components.showToast('Descuento eliminado correctamente.');
                                    this.order.discounts = discounts.filter(({ $key }) => discount.$key !== $key);
                                    this.getTotal();
                                }, err => {
                                    console.log(err);
                                })
                            }
                        }
                    }
                ]
            });

            await alert.present();
        } else {
            const alert = await this.alertController.create({
                header: 'Eliminar promocion',
                message: `Estas seguro que deseas eliminar el descuento ${discount.name}?, esta acción no se puede revertir.`,
                buttons: [
                    {
                        text: 'Cancelar',
                        role: 'cancel'
                    },
                    {
                        text: 'Remover propina',
                        role: 'destructive',
                        handler: () => {
                            this.api.deleteDocument(`accounts/${this.auth.account}/ticket_discounts`, discount.$key).then(() => {
                                this.modalController.dismiss();
                                this.components.showToast('Descuento eliminado correctamente.');
                            }, err => {
                                console.log(err);
                            })
                        }
                    }
                ]
            });

            await alert.present();
        }
    }

    async ticketOptions() {
        if (!this.components.isModalPresent) {
            this.components.isModalPresent = true;
            const modal = await this.modalController.create({
                component: ModalBaseComponent,
                cssClass: 'ticket-options-modal',
                showBackdrop: true,
                backdropDismiss: true,
                componentProps: {
                    rootPage: TicketOptionsComponent,
                    params: {
                        order: this.order,
                        payments: this.payments,
                        total: this.total + this.tip,
                        discount_card: this.discount_card,
                        currentTotal: this.total
                    }
                }
            });
            await modal.present().then(() => { this.components.isModalPresent = false })

            await modal.onDidDismiss().then(async (data) => {
                if (data.data == 'returned') {
                    this.discount_card = null;
                    this.router.navigate([`pos`]);
                    this.clearAll();
                }
                if (data?.data?.note) {
                    if (this.order) {
                        this.order.notes = data.data.note;
                    }
                }
                if (data?.data?.$key) {
                    this.discount_card = data.data
                }
                if (data?.data?.code === 'deleted') {
                    this.discount_card = null
                    this.order.discount_card = null
                    this.components.showToast('Tarjeta de descuento fue removida.');
                }
                this.getTotal();
            })
        }
    }

    async getPayments(order_key: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let payments = []
            this.api
                .getRef(`accounts/${this.auth.account}/ticket_payments`)
                .ref.where('order_key', '==', order_key)
                .orderBy('creation_date')
                .onSnapshot(
                    (snapshots) => {
                        snapshots.docChanges().forEach((element: any) => {
                            let payment = element.doc.data();
                            payment.$key = element.doc.id;
                            if (payment.creation_date !== null) {
                                payment.creation_date = payment.creation_date.toDate();
                            }
                            payments.push(payment);
                        });
                        resolve(payments);
                    },
                    (err) => {
                        console.log(err);
                        reject(err);
                    }
                );
        });
    }


    async printOrder() {

        if (!this.auth.license.membership.features.tickets.print) {
            this.components.showAlert('Actualiza tu licencia', 'Al actualizar tu licencia podrás imprimir ordenes.', ['Aceptar']);
        } else {

            let order = JSON.parse(JSON.stringify(this.order));
            let total_payments = 0;
            let splitted_amount = 0;
            let pending_total = 0;
            order.iva_rete = this.iva_rete;

            await this.getPayments(order.$key)
                .then((payments) => order.payments = payments)

            let total = this.total + this.tip;
            let subtotal = Math.max(0, (total + this.gran_discount) - this.hidden_taxes);

            let tip = this.tip;
            let discount = this.gran_discount + this.iva_discount;
            let exempt = 0;

            if (this.pos.exempt) {
                exempt = this.hidden_taxes
            }

            let creation_date = this.order.creation_date;

            if (creation_date instanceof Date) {
                order.creation_date = creation_date;
            } else {
                order.creation_date = creation_date.toDate();
            }

            order.payments.forEach((element) => {
                total_payments += element.total;
            });

            pending_total = (total) - total_payments;

            if (order.splitted) {
                if (order.splitted_payments <= order.splitted) {
                    splitted_amount = 0;
                    splitted_amount = (total) / order.splitted;
                } else {
                    splitted_amount = pending_total;
                }
            }


            order.taxes = this.hidden_taxes;
            if (this.platform.is('cordova') || this.printer.quanto_prints) {
                this.printer.printOrder(order, subtotal, total, tip, pending_total, discount, false, exempt);
            } else {
                if (this.printer.quanto_prints) {
                    this.printer.printOrder(order, subtotal, total, tip, pending_total, discount, false, exempt);
                } else {
                    this.printer.pdfOrder(order, subtotal, total, tip, pending_total, discount, false, exempt);
                }
            }

        }
    }

    async goToChangeTablePage() {
        const modal = await this.modalController.create({
            component: TransferTicketsComponent,
            cssClass: 'full-modal',
            canDismiss: true,
            showBackdrop: true,
            backdropDismiss: true,
            componentProps: {
                orders: [this.order]
            }
        });

        await modal.present();

        modal.onDidDismiss().then(data => {
            if (data.data) {
                this.order.table = this.pos.table;
                this.order.table_area = this.pos.table_area;
            }
        })
    }

    async updatePeople() {
        const modal = await this.modalController.create({
            component: NumberComponent,
            cssClass: 'auto-height number-modal',
            canDismiss: true,
            showBackdrop: true,
            backdropDismiss: false,
            componentProps: {
                order: this.order,
                is_update: true,
                peopleConfirmation: true,
                table: {
                    text: this.pos.table
                }
            }
        });
        await modal.present();
    }

    cancelOrder() {
        this.pos.cancelOrder(undefined).then(() => {
            this.order = false;
            this.total = 0;
            this.total_payments = 0;
            this.payments = [];
            this.client = false;
            this.tip = 0;
            this.gran_discount;
            this.hidden_taxes = 0;
            this.open_payment_modal = false;
            this.iva_discount = 0;
            this.iva_rete = 0;
        });

        if (this.components.isApp()) {
            this.modalController.dismiss();
        }
    }

    async removeDiscountCard(discount, messege = null) {
        const alert = await this.alertController.create({
            header: messege ?? 'Remover tarjeta de descuento',
            message: messege ? 'Para continuar con tu pago, remueve la tarjeta de descuento.' : 'Estas seguro que deseas remover tarjeta de descuento ?',
            buttons: [
                {
                    text: 'Cancelar',
                    role: 'cancel'
                },
                {
                    text: 'Remover tarjeta',
                    role: 'destructive',
                    handler: () => {
                        if (this.order) {
                            const discounts = this.order.discounts;
                            this.api.deleteDocument(`accounts/${this.auth.account}/ticket_discounts`, discount.$key).then(async () => {
                                await this.api.removeDiscountCardFromOrder(this.order)
                                this.order.discounts = discounts.filter(({ $key }) => discount.$key !== $key);
                                this.components.showToast('Tarjeta de descuento fue removida.');
                                this.discount_card = null;
                                this.order.discount_card = null;
                            }, err => {
                                console.log(err);
                            })
                            this.getTotal();
                        }

                        if (!this.order) {
                            this.pos.removeDiscount(discount);
                            this.discount_card = null;
                            this.components.showToast('Tarjeta de descuento fue removida.');
                        }
                    }
                }
            ]
        });

        await alert.present();
    }
    async invalidDiscountCard(message,) {
        const discount = this.order.discounts.find(({ isDiscountCard }) => isDiscountCard === true);
        if (discount) {
            if (discount) {
                await this.removeDiscountCard(discount, message)
                return;
            }
        }
    }

    canPrintPreOrder() {
        if (!this.order) {
            return !this.order;
        }

        if (this.pos.items.length > 0) {
            return !false;
        }

    }
}
